import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

export type ButtonColor =
  | "primary"
  | "secondary"
  | "secondary-radio"
  | "green-outline"
  | "grey-outline"
  | "green-filled"
  | "red-filled";

@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonComponent {
  @Input() label: string = "";
  @Input() color: ButtonColor = "primary";
  @Input() iconBefore: string | null = null; // e.g. "assets/icons/download.png" | "fa-solid fa-download"
  @Input() iconAfter: string | null = null;
  @Input() iconType: "image" | "fontawesome" = "image";
  @Input() disabled: boolean = false;
  @Input() dataId: string;

  @Output() clicked = new EventEmitter<void>();

  isImagePath(icon: string): boolean {
    return (
      icon.startsWith("assets/") ||
      icon.startsWith("http") ||
      icon.startsWith("data:")
    );
  }

  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
